'use client';

import { useTranslations } from 'next-intl';
import type { HintKey } from '../hooks/useKeyFlash';
import { Kbd } from './Kbd';

interface SearchHintsProps {
  /** The key just pressed, whose cap dips. */
  hitKey: HintKey | null;
  /** Esc clears the query and tab first, and only then closes. */
  canClear: boolean;
}

/** The panel's footer: what the keyboard does here. */
export function SearchHints({ hitKey, canClear }: SearchHintsProps) {
  const t = useTranslations('search.hints');
  return (
    <div
      aria-hidden
      className="flex h-8 items-center gap-3.5 whitespace-nowrap border-t border-solid border-v2-border px-3 text-[11px] leading-none text-v2-text-secondary dark:border-v2-surface-tertiary"
    >
      <span className="flex items-center gap-1.5">
        <span className="flex gap-0.5">
          <Kbd hit={hitKey === 'up'}>↑</Kbd>
          <Kbd hit={hitKey === 'down'}>↓</Kbd>
        </span>
        {t('navigate')}
      </span>
      <span className="flex items-center gap-1.5">
        <Kbd hit={hitKey === 'enter'}>↵</Kbd>
        {t('open')}
      </span>
      <span className="flex items-center gap-1.5">
        <Kbd hit={hitKey === 'tab'}>Tab</Kbd>
        {t('filter')}
      </span>
      <span className="ml-auto flex items-center gap-1.5">
        <Kbd hit={hitKey === 'esc'}>esc</Kbd>
        {canClear ? t('clear') : t('close')}
      </span>
    </div>
  );
}
